import {Box, Drawer, styled} from '@mui/material';

const StyledDrawer = styled(Drawer)``;

const DrawerContent = styled(Box)<{$isMobile: boolean}>`
	display: flex;
	flex-direction: column;
	height: 100%;
	width: ${({$isMobile}) => ($isMobile ? '100%' : '600px')};
`;

const ScrollableContent = styled(Box)`
	flex: 1;
	overflow-y: auto;
`;

export {DrawerContent, ScrollableContent, StyledDrawer};
